/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Overview_MetaInputs */

const cs_clients_overview_meta = /** @type {(inputs: Clients_Overview_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav a zdroj`)
};

const en_clients_overview_meta = /** @type {(inputs: Clients_Overview_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status & source`)
};

/**
* | output |
* | --- |
* | "Status & source" |
*
* @param {Clients_Overview_MetaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_overview_meta = /** @type {((inputs?: Clients_Overview_MetaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Overview_MetaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_overview_meta(inputs)
	return cs_clients_overview_meta(inputs)
});